import React from 'react'


function Stats() {
    return (
        <div className='container  px-5 mt-5 '>
            <div className='row'>
                <div className='col-6'>
                    <h2>Trust with confidence</h2>
                    <br></br>
                    <h4>Customer-first always</h4> 
                    <p style={{color: "gray", width: "65%"}}>That's why 1.6+ crore customers trust Zerodha with ~ ₹6 lakh crores of equity investments, making us India’s largest broker; contributing to 15% of daily retail exchange volumes in India.</p>

                    <h4>No spam or gimmicks</h4>
                    <p style={{color: "gray", width: "65%"}}>No gimmicks, spam, "gamification", or annoying push notifications. High quality apps that you use at your pace, the way you like. Our philosophies.</p>

                    <h4>The Zerodha universe</h4>
                    <p style={{color: "gray", width: "65%"}}>Not just an app, but a whole ecosystem. Our investments in 30+ fintech startups offer you tailored services specific to your needs.</p>
                    
                    <h4>Do better with money</h4>
                    <p style={{color: "gray", width: "65%"}}>With initiatives like Nudge and Kill Switch, we don't just facilitate transactions, but actively help you do better with your money.</p>
                </div>
                <div className='col-6'>
                    <img src='media/ecosystem.png' style={{ width: '100%' }} alt='img'/>
                    <div className='text-center'>
                        <a href='' className='mx-2' style={{textDecoration: "none"}}>Explore our produsts</a> 
                        <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                        <a href='' className='mx-3'  style={{textDecoration: "none"}}>Try Kite</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Stats;